module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAQAAABIkb+zAAABE0lEQVR4Ae3aRUEFUBQA0RcBd42DN8DXWBkK0ACHINged/fBXb77nAbz5K5uUPQkSZJIsewIMMAAAwwwwAADDDDAAAMkUcoA0yxzSrqdsMwUgxSHeNHIONdk2hXj1IXY0cUF2eKCrhAbhsk2wyF6tHNPtrmnM0SHGs7IRufURhcwQbaaCJHRTDZrjhwwRqZt0EoZZXSwwXdjkQMWyKx9qsMrqtnjq8XIAWtkVl/4hF6+WosccEZm1X+biF+dRg7ItJrwCXV8k/0BPeET+nIvYPvLJ97PvQDYpJ1yymhnE7I/IDIDDDDAAAOyOCAkyAADDDDAAAMMMCCbAiJJdUBINTDAAAMMMMCNLQMMMMAAAyRJkvQABm6nE+AtK4gAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/image/baseline_print_white.png
// module id = 323
// module chunks = 0